// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2uPg9","name":"Header_name__160xD","birthday":"Header_birthday__2YKA_","skeleton":"Header_skeleton__3dKRX"};